import {startCase} from 'lodash';
import Vue from 'vue';

const dotize = function(jsonobj, prefix) {
  let newobj = {};

  function recurse(object, prefix) {
    Object.keys(object).forEach(field => {
      const pre = (prefix === undefined ? '' : prefix + '.');
      if (object[field] && typeof object[field] === 'object') {
        newobj = recurse(object[field], pre + field);
      } else {
        newobj[pre + field] = object[field];
      }
    });
    return newobj;
  }

  return recurse(jsonobj, prefix);
};

class Errors {
  constructor(errors) {
    this.errors = errors;
    this.validations = {};
    this.fields = {};
    this.formData = {};
  }

  validation(validations, fields = {}) {
    Vue.set(this, 'validations', validations);
    Vue.set(this, 'fields', fields);

    return this;
  }

  setData(data, reset = false) {
    if (reset) {
      Vue.set(this, 'formData', data);

      return this;
    }

    Vue.set(this, 'formData', {
      ...this.formData,
      ...data
    });

    return this;
  }

  addValidation(validations, fields = {}) {
    Vue.set(this, 'validations', {
      ...this.validations,
      ...validations
    });

    Vue.set(this, 'fields', {
      ...this.fields,
      ...fields
    });

    return this;
  }

  clearValidations() {
    Vue.set(this, 'validations', {});
  }

  isRequired(field) {
    if (!this.validations.hasOwnProperty(field)) {
      return false;
    }

    return this.validations[field].match(/required/);
  }

  addFieldLabel(field, label) {
    Vue.set(this.fields, field, label);

    return this;
  }

  removeValidation(fields) {
    if (!Array.isArray(fields)) {
      return Vue.delete(this.validations, fields);
    }

    fields.forEach(field => Vue.delete(this.validations, field));
  }

  trans(key, replace = null) {
    return window.trans(key, replace);
  }

  getData() {
    return this.formData;
  }

  validate(form, dot = false) {
    form = {
      ...this.formData,
      ...form
    };

    if (dot) {
      form = dotize(form);
    }

    let numericFields = [];
    // percorre as configurações de validação e executa as verificações necessárias
    Object.keys(this.validations).forEach(field => {
      let formField = form[field];
      let validation = this.validations[field];
      let fieldName = this.fields[field] ? this.fields[field] : field;

      this.remove(field);
      let rules = Array.isArray(validation) ? validation : validation.split('|');
      let confirmField = null;
      rules.forEach(rule => {
        if (/^required_if:/.test(rule)) {
          let parameters = rule.match(/^required_if:([^,]+),(.+)$/);

          if (form[parameters[1]] === parameters[2]) {
            rule = 'required';
          }
        }

        if (rule === 'numeric') {
          numericFields.push(field);
          if (typeof parseInt(formField) !== 'number') {
            let message = this.trans('validation.numeric', {Attribute: startCase(fieldName.toLowerCase())});
            this.add(field, message);
          }
        }

        if (/^gt:/.test(rule)) {
          let parameters = rule.match(/^gt:([^,]+)$/);
          let value = this.trans(parameters[1]);

          if (formField <= form[parameters[1]]) {
            let message = this.trans('validation.gt.numeric', {Attribute: startCase(fieldName.toLowerCase()), value});
            this.add(field, message);
          }
        }

        if (/^min:/.test(rule)) {
          let parameters = rule.match(/^min:([0-9]+)$/);
          let min = parameters[1];
          // console.log({numericFields, formField});

          if (numericFields.includes(field)) {
            if (formField && parseInt(formField) < parseInt(min)) {
              let message = this.trans('validation.min.numeric', {Attribute: startCase(fieldName.toLowerCase()), min});
              this.add(field, message);
            }
          } else {
            if (formField && formField.length < parseInt(min)) {
              let message = this.trans('validation.min.string', {Attribute: startCase(fieldName.toLowerCase()), min});
              this.add(field, message);
            }
          }
        }

        if (/^max:/.test(rule)) {
          let parameters = rule.match(/^max:([0-9]+)$/);
          let max = parameters[1];

          if (formField && formField.length > parseInt(max)) {
            let message = this.trans('validation.max.string', {Attribute: startCase(fieldName.toLowerCase()), max});
            this.add(field, message);
          }
        }

        if (/^regex:/.test(rule)) {
          let parameters = rule.split(':');
          let regex = {
            phone: /^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{2}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})$/
          };

          if (formField && formField.length &&
            !formField.match(regex[parameters[1]])) {
            this.add(field, this.trans(
              'validation.date_format',
              {
                Attribute: startCase(fieldName.toLowerCase()),
                format: '+9 999 9999 9999'
              })
            );
          }
        }

        if (rule === 'required' && (!formField || formField.length <= 0)) {
          this.add(field, this.trans('validation.required', startCase(fieldName.toLowerCase())));
        }

        if (rule === 'accept' && formField !== true) {
          this.add(field, this.trans('validation.accepted', startCase(fieldName.toLowerCase())));
        }

        if (rule === 'email') {
          const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          if (!formField || !emailRegex.test(formField.toLowerCase())) {
            this.add(field, this.trans('validation.regex', startCase(fieldName.toLowerCase())));
          }
        }

        if (['confirmed', 'confirm'].includes(rule)) {
          confirmField = form[`${field}_confirm`];
          if (!formField || !confirmField || formField !== confirmField) {
            this.add(`${field}_confirm`, this.trans('validation.confirmed').replace(':Attribute', startCase(fieldName.toLowerCase())));
          }
        }

        if (typeof rule === 'function') {
          return rule(field, formField, (message) => {
            this.add(field, message);
          });
        }

        if (rule === 'full_name') {
          const nameRegex = /^[ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zÀ-úA-Z\xC0\-\\uFFFF.]+ [ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zÀ-úA-Z\xC0\-\\uFFFF. ]{2,}$/;

          if (!formField || !nameRegex.test(formField)) {
            this.add(field, this.trans('validation.required', this.trans('dashboard.user-info-name')));
          }
        }

        if (rule === 'valid_phone') {
          const phoneRegex = /^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{2}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})$/;

          if (!formField || !phoneRegex.test(formField)) {
            this.add(field, this.trans('validation.regex', this.trans('dashboard.phone')));
          }
        }

        // TODO: Validação VAT NUMBER
        if (rule === 'vat_number' && form.type && form.type === 'business' && (!formField || formField === 'INVALID')) {
          this.add(field, this.trans('validation.regex', startCase(fieldName.toLowerCase())));
        }
      });
    });

    return !this.any();
  }

  has(field) {
    if (Array.isArray(field)) {
      let exists = field.filter(f => this.errors.hasOwnProperty(f));
      return exists.length !== 0;
    }

    return this.errors.hasOwnProperty(field);
  }

  hasValidation(field) {
    if (Array.isArray(field)) {
      let exists = field.filter(f => this.validations.hasOwnProperty(f));
      return exists.length !== 0;
    }

    return this.validations.hasOwnProperty(field);
  }

  any(exclude = []) {
    return !!Object.keys(this.errors).filter(key => !exclude.includes(key)).length;
  }

  all(exclude = []) {
    if (!this.any(exclude)) {
      return [];
    }
    let errors = [];

    Object.keys(this.errors).forEach(key => {
      if (exclude && exclude.includes(key)) {
        return;
      }
      errors.push(this.errors[key][0]);
    });

    return errors;
  }

  first(field) {
    if (!field) {
      return Object.keys(this.errors)[0];
    }

    if (this.errors[field]) {
      return this.errors[field][0];
    }
  }

  add(field, message) {
    if (this.errors[field]) {
      this.errors[field].push([message]);
      Vue.set(this.errors, field, this.errors[field]);
      return;
    }

    Vue.set(this.errors, field, [message]);
  }

  remove(fields) {
    if (!Array.isArray(fields)) {
      return Vue.delete(this.errors, fields);
    }
    fields.forEach(field => Vue.delete(this.errors, field));
  }

  record(errors, mapping = null) {
    if (mapping) {
      Object.keys(mapping).forEach(k => {
        if (!errors[k]) return;
        errors[mapping[k]] = errors[k];
        delete errors[k];
      });
    }

    Vue.set(this, 'errors', errors);
    this.errors = errors;
  }

  clear() {
    Vue.set(this, 'errors', {});
  }
}

export {Errors as default};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Checkout/Util/errors.js